import { AxiosResponse } from "axios";
import { axiosInstance } from "../AxiosInterceptor";
import * as ApiUrls from "./ApiUrl.License";

export const LicenseService = {
    ExpressEE123Interest: (): Promise<AxiosResponse> => {
        return axiosInstance.get(ApiUrls.ExpressEE123Interest);
    }
}